/* tslint:disable */
/* eslint-disable */
/**
 * Pinwheel - Main Service API
 * Pinwheel - Main Service API
 *
 * The version of the OpenAPI document: 2.97.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Child subscription types
 * @export
 * @enum {string}
 */

export enum ChildSubscriptionType {
    Phone = 'Phone',
    Watch = 'Watch',
    Cellular = 'Cellular',
    HomeFree = 'HomeFree',
    HomeFf = 'HomeFF',
    HomeUnlimited = 'HomeUnlimited',
    HomeGlobal = 'HomeGlobal'
}


